(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["er-reviews"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-er-reviews]').forEach(function (root) {
    if (root.dataset.erReviewsInit) return;
    root.dataset.erReviewsInit = '1';
    var slides = root.querySelectorAll('.er-reviews__slide');
    var dashes = root.querySelectorAll('.er-reviews__dash');
    var idx = 0;
    function show(n) {
      idx = (n + slides.length) % slides.length;
      slides.forEach(function (s, i) { s.classList.toggle('is-active', i === idx); });
      dashes.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
    }
    var prev = root.querySelector('[data-review-prev]');
    var next = root.querySelector('[data-review-next]');
    if (prev) prev.addEventListener('click', function () { show(idx - 1); });
    if (next) next.addEventListener('click', function () { show(idx + 1); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["er-stories"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var STORY_MS = 5000;

    document.querySelectorAll('[data-er-stories]').forEach(function (section) {
      if (section.dataset.erStoriesInit) return;
      section.dataset.erStoriesInit = '1';

      var raw;
      try {
        raw = JSON.parse(section.querySelector('[data-stories-json]').textContent);
      } catch (e) {
        return;
      }

      // group consecutive items by stack name
      var stacks = [];
      raw.forEach(function (item) {
        var last = stacks[stacks.length - 1];
        if (!last || last.name !== item.stack) {
          stacks.push({ name: item.stack, avatar: item.avatar, avatarPosition: item.avatarPosition, items: [] });
        }
        stacks[stacks.length - 1].items.push(item);
      });
      if (!stacks.length) return;

      // render circles
      var rail = section.querySelector('[data-stories-rail]');
      stacks.forEach(function (stack, i) {
        var btn = document.createElement('button');
        btn.className = 'er-stories__circle';
        btn.setAttribute('aria-label', 'View ' + stack.name + ' stories');
        btn.innerHTML =
          '<span class="er-stories__ring"><span class="er-stories__avatar">' +
          '<img src="' + stack.avatar + '" alt="" style="object-position:' + (stack.avatarPosition || '50% 50%') + '">' +
          '</span></span>' +
          '<span class="er-stories__name">' + stack.name + '</span>';
        btn.addEventListener('click', function () { openViewer(i); });
        rail.appendChild(btn);
      });

      var viewer = null;
      var state = { s: 0, i: 0, elapsed: 0, paused: false, raf: 0, liked: false };
      var holdTimer = null;
      var holding = false;

      function esc(s) {
        return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
          return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
        });
      }

      function closeViewer() {
        if (!viewer) return;
        cancelAnimationFrame(state.raf);
        var _v = viewer.querySelector('.er-story-viewer__video');
        if (_v) { _v.pause(); _v.removeAttribute('src'); }
        viewer.remove();
        viewer = null;
        document.documentElement.classList.remove('er-lock');
        window.removeEventListener('keydown', onKey);
      }

      function onKey(e) {
        if (e.key === 'Escape') closeViewer();
        if (e.key === 'ArrowRight') goNext();
        if (e.key === 'ArrowLeft') goPrev();
      }

      function goNext() {
        state.elapsed = 0;
        state.liked = false;
        if (state.i < stacks[state.s].items.length - 1) {
          state.i += 1;
        } else if (state.s < stacks.length - 1) {
          state.s += 1;
          state.i = 0;
        } else {
          closeViewer();
          return;
        }
        renderItem();
      }

      function goPrev() {
        state.elapsed = 0;
        state.liked = false;
        if (state.i > 0) {
          state.i -= 1;
        } else if (state.s > 0) {
          state.s -= 1;
          state.i = 0;
        }
        renderItem();
      }

      function setMedia(item) {
        var img = viewer.querySelector('.er-story-viewer__media');
        var vid = viewer.querySelector('.er-story-viewer__video');
        if (item.video) {
          img.hidden = true;
          vid.hidden = false;
          if (vid.getAttribute('src') !== item.video) vid.src = item.video;
          try { vid.currentTime = 0; } catch (e) {}
          vid.muted = false;
          vid.volume = 1;
          var p = vid.play();
          if (p && p.catch) p.catch(function () { vid.muted = true; var q = vid.play(); if (q && q.catch) q.catch(function () {}); });
        } else {
          vid.pause();
          vid.hidden = true;
          vid.removeAttribute('src');
          img.hidden = false;
          img.src = item.src;
        }
      }

      function syncVid() {
        var vid = viewer && viewer.querySelector('.er-story-viewer__video');
        if (!vid || vid.hidden) return;
        if (state.paused && !vid.paused) vid.pause();
        else if (!state.paused && vid.paused && !vid.ended) { var q = vid.play(); if (q && q.catch) q.catch(function () {}); }
      }

      function curRatio() {
        var vid = viewer && viewer.querySelector('.er-story-viewer__video');
        if (vid && !vid.hidden && vid.duration) return Math.min(vid.currentTime / vid.duration, 1);
        return Math.min(state.elapsed / STORY_MS, 1);
      }

      function renderItem() {
        var stack = stacks[state.s];
        var item = stack.items[state.i];

        setMedia(item);

        var bars = viewer.querySelector('.er-story-viewer__bars');
        bars.innerHTML = stack.items
          .map(function (_, idx) {
            var fill = idx < state.i ? 'scaleX(1)' : 'scaleX(0)';
            return '<div class="er-story-viewer__bar"><span style="transform:' + fill + '"' + (idx === state.i ? ' data-fill-active' : '') + '></span></div>';
          })
          .join('');

        viewer.querySelector('.avatar img').src = stack.avatar;
        viewer.querySelector('.avatar img').style.objectPosition = stack.avatarPosition || '50% 50%';
        viewer.querySelector('.who .name').textContent = stack.name;

        var copy = viewer.querySelector('.er-story-viewer__copy');
        var html = '';
        if (item.kicker) html += '<p class="kicker">' + esc(item.kicker) + '</p>';
        if (item.headline) html += '<p class="headline">' + esc(item.headline) + '</p>';
        if (item.ctaLabel && item.ctaHref) {
          html += '<a class="cta" href="' + esc(item.ctaHref) + '">' + esc(item.ctaLabel) + ' →</a>';
        }
        copy.innerHTML = html;

        var likeBtn = viewer.querySelector('[data-story-like]');
        likeBtn.classList.toggle('is-liked', state.liked);

        // preload next
        var next =
          (stack.items[state.i + 1] && stack.items[state.i + 1].src) ||
          (stacks[state.s + 1] && stacks[state.s + 1].items[0].src);
        if (next) {
          var img = new Image();
          img.src = next;
        }
      }

      function tick(last) {
        var now = performance.now();
        var dt = Math.min(now - last, 64);
        syncVid();
        if (!state.paused) {
          state.elapsed += dt;
          var ratio = curRatio();
          var fill = viewer && viewer.querySelector('[data-fill-active]');
          if (fill) fill.style.transform = 'scaleX(' + ratio + ')';
          if (ratio >= 1) goNext();
        }
        if (viewer) state.raf = requestAnimationFrame(function () { tick(now); });
      }

      function openViewer(index) {
        state = { s: index, i: 0, elapsed: 0, paused: false, raf: 0, liked: false };
        viewer = document.createElement('div');
        viewer.className = 'er-story-viewer';
        viewer.innerHTML =
          '<div class="er-story-viewer__frame">' +
          '  <img class="er-story-viewer__media" alt="Earth Revibe story">' +
          '  <video class="er-story-viewer__video" playsinline preload="auto" hidden></video>' +
          '  <div class="er-story-viewer__grad-top"></div>' +
          '  <div class="er-story-viewer__grad-bottom"></div>' +
          '  <div class="er-story-viewer__gestures"></div>' +
          '  <div class="er-story-viewer__bars"></div>' +
          '  <div class="er-story-viewer__identity">' +
          '    <span class="avatar"><img alt=""></span>' +
          '    <div class="who"><p class="name"></p><p class="sub">earthrevibe · now</p></div>' +
          '    <button class="er-story-viewer__close" data-story-close aria-label="Close stories">' +
          '      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>' +
          '    </button>' +
          '  </div>' +
          '  <div class="er-story-viewer__copy"></div>' +
          '  <div class="er-story-viewer__bottom">' +
          '    <input readonly placeholder="Send message" aria-label="Send message">' +
          '    <button class="actbtn" data-story-like aria-label="Like story">' +
          '      <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M2 9.5a5.5 5.5 0 0 1 9.591-3.676.56.56 0 0 0 .818 0A5.49 5.49 0 0 1 22 9.5c0 2.29-1.5 4-3 5.5l-5.492 5.313a2 2 0 0 1-3 .019L5 15c-1.5-1.5-3-3.2-3-5.5"/></svg>' +
          '    </button>' +
          '    <button class="actbtn" data-story-share aria-label="Share story">' +
          '      <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11z"/><path d="m21.854 2.147-10.94 10.939"/></svg>' +
          '    </button>' +
          '  </div>' +
          '</div>';
        document.body.appendChild(viewer);
        document.documentElement.classList.add('er-lock');
        window.addEventListener('keydown', onKey);

        viewer.querySelector('[data-story-close]').addEventListener('click', closeViewer);
        viewer.querySelector('[data-story-like]').addEventListener('click', function () {
          state.liked = !state.liked;
          this.classList.toggle('is-liked', state.liked);
        });
        viewer.querySelector('[data-story-share]').addEventListener('click', function () {
          var stack = stacks[state.s];
          var item = stack.items[state.i];
          if (navigator.share) {
            navigator
              .share({
                title: 'Earth Revibe — ' + stack.name,
                url: window.location.origin + (item.ctaHref || '/'),
              })
              .catch(function () {});
          }
        });

        // tap / hold gestures
        var g = viewer.querySelector('.er-story-viewer__gestures');
        g.addEventListener('pointerdown', function () {
          holding = false;
          holdTimer = setTimeout(function () {
            holding = true;
            state.paused = true;
          }, 200);
        });
        g.addEventListener('pointerup', function (e) {
          clearTimeout(holdTimer);
          if (holding) {
            holding = false;
            state.paused = false;
            return;
          }
          var rect = e.currentTarget.getBoundingClientRect();
          var x = e.clientX - rect.left;
          if (x < rect.width / 3) goPrev();
          else goNext();
        });
        ['pointerleave', 'pointercancel'].forEach(function (evt) {
          g.addEventListener(evt, function () {
            clearTimeout(holdTimer);
            holding = false;
            state.paused = false;
          });
        });
        g.addEventListener('contextmenu', function (e) { e.preventDefault(); });

        // swipe-down dismiss
        var frame = viewer.querySelector('.er-story-viewer__frame');
        var startY = null;
        var startT = 0;
        frame.addEventListener('touchstart', function (e) {
          startY = e.touches[0].clientY;
          startT = performance.now();
        }, { passive: true });
        frame.addEventListener('touchmove', function (e) {
          if (startY == null) return;
          var dy = e.touches[0].clientY - startY;
          if (dy > 0) frame.style.transform = 'translateY(' + dy * 0.7 + 'px)';
        }, { passive: true });
        frame.addEventListener('touchend', function (e) {
          if (startY == null) return;
          var dy = e.changedTouches[0].clientY - startY;
          var vel = (dy / Math.max(performance.now() - startT, 1)) * 1000;
          frame.style.transform = '';
          if (dy > 120 || vel > 700) closeViewer();
          startY = null;
        });

        renderItem();
        state.raf = requestAnimationFrame(function () { tick(performance.now()); });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
